import styled from "styled-components";
import Button from "@/components/UI/Button/Button";

export const SubmitStyled = styled(Button)`
    cursor: ${({ loading }) => (loading ? "not-allowed" : "pointer")};
    &:disabled {
        cursor: not-allowed;
    }
`;
